import { stripeCloudFunctionsApi } from "@docsndata/stripe-cloud-functions-api";
import { amountWithoutDecimalPlaces } from "@docsndata/stripe-cloud-functions-api";
export async function prepareStripeCheckout(paymentRequest, tenantId, environment, metadata) {
    const uri = stripeCloudFunctionsApi.v1.payg.checkout.post.uri.constructor(tenantId, environment);
    const body = stripeCloudFunctionsApi.v1.payg.checkout.post.body.forCustomerRecord(amountWithoutDecimalPlaces(paymentRequest.amount * 100), "gbp", paymentRequest.customer._recordId, metadata);
    const url = stripeCloudFunctionsApi.v1.fullyQualifiedUrl(uri);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    const { clientSecret, publicKey } = await response.json();
    return { clientSecret, publicKey };
}
